import { Outlet, Link, useNavigate } from 'react-router-dom'
import { Bot, Menu, X, LogOut } from 'lucide-react'
import { useState } from 'react'

interface LayoutProps {
  token: string | null
  setToken: (token: string | null) => void
}

export default function Layout({ token, setToken }: LayoutProps) {
  const [menuOpen, setMenuOpen] = useState(false)
  const navigate = useNavigate()

  const logout = () => {
    localStorage.removeItem('token')
    setToken(null)
    navigate('/')
  }

  return (
    <div className="min-h-screen relative">
      <div className="fixed inset-0 bg-grid pointer-events-none z-0" />
      
      <nav className="fixed top-0 w-full z-50 bg-dark/90 backdrop-blur-xl border-b border-glass-border">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Bot className="w-7 h-7 text-primary" />
            <span className="font-black text-xl text-white">
              AI<span className="text-primary">Agent</span>
            </span>
          </Link>
          
          <div className="hidden md:flex items-center gap-8">
            <Link to="/pricing" className="text-sm text-text-muted hover:text-white transition">Pricing</Link>
            {token ? (
              <>
                <Link to="/dashboard" className="text-sm text-primary font-semibold">Dashboard</Link>
                <button onClick={logout} className="flex items-center gap-2 text-sm text-text-muted hover:text-accent transition">
                  <LogOut className="w-4 h-4" />
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-sm text-text-muted hover:text-white transition">Sign In</Link>
                <Link to="/register" className="px-5 py-2 bg-primary text-dark font-semibold text-sm rounded-full hover:opacity-90 transition">
                  Get Started
                </Link>
              </>
            )}
          </div>
          
          <button className="md:hidden" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        
        {menuOpen && (
          <div className="md:hidden border-t border-glass-border bg-dark/95 backdrop-blur-xl">
            <div className="px-6 py-4 space-y-3">
              <Link to="/pricing" className="block text-text-muted hover:text-white">Pricing</Link>
              {token ? (
                <>
                  <Link to="/dashboard" className="block text-primary font-semibold">Dashboard</Link>
                  <button onClick={logout} className="text-accent">Logout</button>
                </>
              ) : (
                <>
                  <Link to="/login" className="block text-text-muted">Sign In</Link>
                  <Link to="/register" className="block text-primary font-semibold">Get Started</Link>
                </>
              )}
            </div>
          </div>
        )}
      </nav>
      
      <main className="relative z-10 pt-16">
        <Outlet />
      </main>
    </div>
  )
}
